function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", {
  id: "free-delivery_svg__defs326"
}, /*#__PURE__*/React.createElement("style", {
  id: "style324"
}, ".free-delivery_svg__cls-1{fill:#5e4dad;stroke:#5e4dad;stroke-miterlimit:10}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "free-delivery_svg__cls-1",
  d: "M70.54 17.133L36.31.613c-.3-.15-.66-.15-.96 0L1.12 17.133c-.38.18-.62.57-.62.99v40.13c0 .42.24.81.62.99l34.23 16.52c.15.07.32.11.48.11.16 0 .33-.04.48-.11l34.23-16.52c.38-.18.62-.57.62-.99v-40.12c0-.42-.24-.81-.62-.99zm-34.71-14.3l31.69 15.3-9.19 4.43c-.06-.04-.12-.09-.19-.12L26.67 7.253zm-11.65 5.67l31.64 15.28-6.48 3.13-31.63-15.27 6.47-3.13zm32.38 17.37v11.56l-6.05 2.92v-11.56zm12.39 31.69l-32.02 15.46v-37.68l7.64-3.69c.55-.27.78-.93.51-1.47-.27-.55-.93-.78-1.47-.51l-7.78 3.76-3.06-1.48a1.1 1.1 0 00-1.47.51c-.26.54-.03 1.21.51 1.47l2.92 1.41v37.68L2.71 57.563v-37.67l24.38 11.77c.15.07.32.11.48.11.41 0 .8-.23 1-.62a1.1 1.1 0 00-.51-1.47L4.15 18.143l10.97-5.3 33.17 16.01.02.02v13.25c0 .38.2.73.52.94.18.11.38.17.59.17.16 0 .33-.04.48-.11l8.26-3.99c.38-.18.62-.57.62-.99v-13.32l10.18-4.92v37.68z",
  id: "free-delivery_svg__path328"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "free-delivery_svg__cls-1",
  d: "M11.82 53.283l-5.02-2.42a1.1 1.1 0 00-1.47.51c-.26.54-.03 1.21.51 1.47l5.02 2.42c.15.07.32.11.48.11.41 0 .8-.23 1-.62.27-.55.04-1.21-.51-1.47z",
  id: "free-delivery_svg__path330"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "free-delivery_svg__cls-1",
  d: "M16.44 50.273l-9.64-4.65a1.1 1.1 0 10-.96 1.98l9.64 4.65c.15.07.32.11.48.11.41 0 .8-.23 1-.62a1.1 1.1 0 00-.51-1.47z",
  id: "free-delivery_svg__path332"
});

function SvgFreeDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "free-delivery_svg__Warstwa_1",
    viewBox: "0 0 71.66 76.373",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgFreeDelivery;